module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Status/images/future_right_2.0dbb0cee.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Status/images/future_right_2.png
// module id = 2857
// module chunks = 11